import React, { useEffect, useState } from "react";
import { useGetDuplicateStagingAttributeGroups } from "../product-compare/hooks/use-get-duplicate-staging-attribute-groups";
import { ProductCompareAttributeRow } from "./product-compare-attribute-row";
import Accordion from "components/accordion";
import { useGroupPairing } from "../../attributes/hooks/use-group-pairing";

export const ProductCompareAttributes = ({ references, productMatches, columnWidths }) => {
    const { data: attributeGroup, isSuccess } = useGetDuplicateStagingAttributeGroups();
    const [definitions, setDefinitions] = useState([]);
    const grouped = useGroupPairing(definitions, "duplicatestaging", true);

    useEffect(() => {
        if (attributeGroup && isSuccess) {
            setDefinitions(attributeGroup);
        }
    }, [isSuccess, attributeGroup]);

    return (
        <div className="attribute-content">
            <Accordion
                className={`accordion-attributes`}
                loadOnOpen={true}
                startingIndexes={[0]}
            >
                <div label="Duplicate Stage Attributes">
                    <div className="product-compare">
                        {grouped.map((attr) => {
                            return (
                                <ProductCompareAttributeRow
                                    key={`${attr[0].uuid}_${attr[0].name}`}
                                    attrGroups={attr}
                                    references={references}
                                    columnWidths={columnWidths}
                                    productMatches={productMatches}
                                />
                            );
                        })}
                    </div>
                </div>
            </Accordion>
        </div>
    );
};
